import * as React from "react";
import { cn } from "@/lib/utils";

export type BadgeVariant =
  | "default"
  | "secondary"
  | "outline"
  | "destructive"
  | "success"
  | "warning";

const variantClasses: Record<BadgeVariant, string> = {
  default: "bg-primary text-foreground border-transparent",
  secondary: "bg-surface-elevated text-foreground border-glass-grey",
  outline: "bg-transparent text-foreground border-glass-grey",
  destructive:
    "bg-signal-crimson/15 text-signal-crimson border-signal-crimson/30",
  success: "bg-signal-green/15 text-signal-green border-signal-green/30",
  warning: "bg-signal-amber/15 text-signal-amber border-signal-amber/30",
};

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

function Badge({ className, variant = "default", ...props }: BadgeProps) {
  return (
    <span
      data-slot="badge"
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors",
        variantClasses[variant],
        className,
      )}
      {...props}
    />
  );
}

export { Badge };
